import { useSectionObserver } from 'hooks/use-section-observer'
import { ArticleContent } from 'components/container'
import { Layout } from 'components/layout'
import { GlobalStyleLight } from 'styles/global-light'
import { PageHeader } from 'components/page-header'
import { PageNav } from 'components/page-nav'
import { Theme } from './styled'
import { PageIntro } from './sections/intro'
import { Independence } from './sections/independence'
import { Leaders } from './sections/leaders'
import { Names } from './sections/names'
import { Reindeer } from './sections/reindeer'
import { Music } from './sections/music'
import { Alphabet } from './sections/alphabet'
import { Olonkho } from './sections/olonkho'
import { Movies } from './sections/movies'
import HeaderImage from './assets/header.webp'

export const Caxa = () => {
  const { addItem } = useSectionObserver()

  return (
    <Layout invertedHeader>
      <GlobalStyleLight />
      <Theme />
      <PageNav />

      <PageHeader title="Саха" imageRatio="1052 / 571" imageUrl={HeaderImage} />

      <ArticleContent>
        <PageIntro />
        <Independence ref={addItem} />
        <Leaders ref={addItem} />
        <Names ref={addItem} />
        <Reindeer />
        <Music ref={addItem} />
        <Alphabet ref={addItem} />
        <Olonkho ref={addItem} />
        <Movies ref={addItem} />
      </ArticleContent>
    </Layout>
  )
}
